import { AppDialogsService } from '@/app/services/app-dialogs.service';
import { State } from '@/app/state/model';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ofType } from '@ces/sourced-action';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BehaviorSubject, merge } from 'rxjs';
import { filter, first, takeUntil } from 'rxjs/operators';
import { addWatchList, watchListAdded, watchListAddFailed } from '../../state/feature/entities/watch-list/watch-list.actions';

@Component({
    selector: 'app-new-watch-list',
    template: `
        <egov-dialog-close-button></egov-dialog-close-button>
        <form [style.width]="'300px'" [style.max-width]="'100%'" [style.display]="'flex'" [style.flex-direction]="'column'">
            <mat-form-field appearance="standard" hideRequiredMarker [style.margin-top]="'-.8em'">
                <mat-label>New list name</mat-label>
                <input #nameField matInput type="text" required maxlength="100" [disabled]="submitting$ | async" />
            </mat-form-field>
            <button
                type="submit"
                mat-flat-button
                class="default spinner-button"
                [class.submitting]="submitting$ | async"
                [style.align-self]="'flex-end'"
                (click)="createNewWatchList(nameField.value)"
                [disabled]="(submitting$ | async) || !nameField.value?.trim()"
            >
                <span class="label">Create</span>
                <app-spinner-button-spinner *ngIf="submitting$ | async"></app-spinner-button-spinner>
            </button>
        </form>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewWatchListDialogComponent
{

    constructor
    (
        // Dependencies

        private readonly store: Store<State>,
        private readonly actions$: Actions,
        private readonly appDialogsService: AppDialogsService,


        // Passed Values

        private readonly dialogRef: MatDialogRef<NewWatchListDialogComponent>,
    )
    {}

    protected readonly submitting$ = new BehaviorSubject(false);

    protected createNewWatchList(name: string)
    {
        // TODO
        // This sign in requirement should probably be part of the `addWatchList` action instead.

        this.appDialogsService.signIn().subscribe(() =>
        {
            this.submitting$.next(true);

            this.store.dispatch(addWatchList('WatchParcelComponent .createNewWatchList()', {
                name,
                notifyErrors: true
            }));

            const added$ = this.actions$.pipe(ofType(watchListAdded), filter(a => a.list.name === name));
            const failed$ = this.actions$.pipe(ofType(watchListAddFailed), filter(a => a.name === name));

            merge(added$, failed$).pipe(first()).subscribe(() => this.submitting$.next(false));
            added$.pipe(first(), takeUntil(failed$)).subscribe(() => this.dialogRef.close());
        });
    }
}
